import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, Check, Info, XCircle } from "lucide-react";

export const ComponentShowcase = () => {
  return (
    <div className="space-y-12">
      {/* Buttons */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">Botones</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Diferentes variantes de botones para distintas acciones
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button variant="default">Default</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="link">Link</Button>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button size="sm">Small</Button>
          <Button size="default">Default</Button>
          <Button size="lg">Large</Button>
          <Button size="icon">
            <Check className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {/* Cards */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">Tarjetas</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Contenedores versátiles para agrupar información
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card>
            <CardHeader>
              <CardTitle>Título de tarjeta</CardTitle>
              <CardDescription>Descripción de la tarjeta</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm">Contenido de la tarjeta con información relevante.</p>
            </CardContent>
            <CardFooter>
              <Button size="sm">Acción</Button>
            </CardFooter>
          </Card>

          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle>Tarjeta Interactiva</CardTitle>
              <CardDescription>Con efecto hover</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm">Esta tarjeta tiene un efecto de sombra al pasar el cursor.</p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Badges */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">Etiquetas</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Para mostrar estados, categorías o información destacada
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Badge>Default</Badge>
          <Badge variant="secondary">Secondary</Badge>
          <Badge variant="destructive">Destructive</Badge>
          <Badge variant="outline">Outline</Badge>
        </div>
      </div>

      {/* Inputs */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">Campos de entrada</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Inputs para capturar información del usuario
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
          <Input placeholder="Texto normal" />
          <Input type="email" placeholder="Email" />
          <Input type="password" placeholder="Contraseña" />
          <Input type="number" placeholder="Número" />
          <Input type="date" />
          <Input disabled placeholder="Deshabilitado" />
        </div>
      </div>

      {/* Alerts */}
      <div className="space-y-4">
        <div>
          <h3 className="text-xl font-semibold mb-2">Alertas</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Mensajes de notificación para el usuario
          </p>
        </div>
        <div className="space-y-3 max-w-2xl">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertTitle>Información</AlertTitle>
            <AlertDescription>
              Esta es una alerta informativa con información importante.
            </AlertDescription>
          </Alert>

          <Alert className="border-viable-green text-viable-green">
            <Check className="h-4 w-4" />
            <AlertTitle>Éxito</AlertTitle>
            <AlertDescription>
              La operación se completó correctamente.
            </AlertDescription>
          </Alert>

          <Alert variant="destructive">
            <XCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>
              Ocurrió un error al procesar la solicitud.
            </AlertDescription>
          </Alert>

          <Alert className="border-yellow-500 text-yellow-600">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Advertencia</AlertTitle>
            <AlertDescription>
              Ten cuidado con esta acción, podría tener consecuencias.
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </div>
  );
};
